/**
 * src/components/header/NavLinks.js
 *
 * Lista de enlaces de navegación principal.
 * Props: { links: Array<{ label, href, name }>, activeRoute: Signal<string> }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { effect } from '@core/signal.js'
import { currentPath } from '@/features/router/router.state.js'

define('NavLinks', ({ links = [] }) => {
    const nav = h('nav', { className: 'nav-links' })
    const ul  = h('ul',  { className: 'nav-links__list' })

    links.forEach(link => {
        const li = h('li', { className: 'nav-links__item' })
        const a  = h('a',  { className: 'nav-links__anchor', href: link.href }, link.label)

        effect(() => {
            const path     = currentPath.get()
            const isActive = link.href === '/'
                ? path === '/'
                : path === link.href || path.startsWith(link.href + '/')
            a.classList.toggle('nav-links__anchor--active', isActive)
        })

        li.appendChild(a)
        ul.appendChild(li)
    })

    nav.appendChild(ul)
    return nav
})
